import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Space, Upload } from 'antd';
import React, { ReactChild } from 'react';
import { RcFile, UploadProps } from 'antd/es/upload';

type ImportMediaUploadProps = {
  accept: UploadProps['accept'];
  onRemove: UploadProps['onRemove'];
  // A bit dumb, but matches the signature in NewDocument
  onFileChange: (e: { target: { files: RcFile[] } }) => Promise<void>;
  children?: ReactChild;
};

function ImportMediaUpload(props: ImportMediaUploadProps) {
  return (
    <>
      <Form.Item required>
        <Space direction='horizontal'>
          <Upload
            accept={props.accept}
            fileList={[]}
            maxCount={1}
            beforeUpload={async (file) => {
              const mockEvent = { target: { files: [file] } };
              await props.onFileChange(mockEvent);
              return false; // Prevent AntD from auto-uploading
            }}
            onRemove={props.onRemove}
          >
            <Button icon={<UploadOutlined />}>{props.children}</Button>
          </Upload>
        </Space>
      </Form.Item>
    </>
  );
}

export default React.memo(ImportMediaUpload);
